import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { OrganizationDTO } from 'artifacts/dtos';

const initialState: OrganizationDTO | null = null;

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    organizationAction: (state, action: PayloadAction<any>) => ({ ...action.payload }),
  },
});

// Action creators are generated for each case reducer function
export const { organizationAction } = organizationSlice.actions;

export default organizationSlice.reducer;
